module.exports = __webpack_public_path__ + "img/icon3.b16c758b.png";